import { Column, Entity, PrimaryGeneratedColumn, OneToOne, JoinColumn } from "typeorm"
import { bigint } from "../../transofrmers/BigInt";
import { ContractTariff } from "./ContractTariff"

@Entity()
export class ContractTariffLiveData {
	
	@PrimaryGeneratedColumn('increment')
	id!: number;

	@OneToOne(() => ContractTariff, contractTariff => contractTariff.live_data, { onDelete:'CASCADE' })
	@JoinColumn()
	contract_tariff!: ContractTariff

  @Column({ type: "bigint", nullable:false, transformer:bigint })
	allowance!: number

	@Column({ type: "bigint", nullable:false, transformer:bigint })
	prorated_allowance!: number

	@Column({default : 0})
  total_sims!: number

	@Column({default : 0})
  active_sims!: number

	@Column({default : 0})
  currently_active_sims!: number

	@Column({ type: "bigint", nullable:false, transformer:bigint })
  advised_daily_usage!: number

	@Column({ type: "bigint", nullable:false, transformer:bigint })
  advised_usage_to_date!: number

	@Column({ type:"float", default : 0})
  usage_ratio!: number

	@Column({ type:"float", default : 0})
  advised_usage_ratio!: number

	@Column({ type: "bigint", nullable:false, transformer:bigint, default:0 })
  total_usage!: number

	@Column({ type: "bigint", nullable:false, transformer:bigint, default:0 })
  total_voice_usage!: number

	@Column({ type: "bigint", nullable:false, transformer:bigint, default:0 })
  total__sms_usage!: number

}